"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _heading = require("../heading");
var _input = require("../input");
var _Banner = _interopRequireDefault(require("./Banner"));
var _Media = _interopRequireDefault(require("./Media"));
var _ColorPicker = _interopRequireDefault(require("./ColorPicker"));
var _helpers = require("./helpers");
var _StyledTemplate = require("./StyledTemplate.style");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Template = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Template, _React$PureComponent);
  var _super = _createSuper(Template);
  function Template(props) {
    var _this;
    _classCallCheck(this, Template);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onToggleText", function () {
      _this.setState(function (prevState) {
        return {
          isCollapsed: !prevState.isCollapsed
        };
      });
      var scrollIntoViewOptions = {
        behavior: 'smooth',
        block: 'start'
      };
      _this.templateRef.current.scrollIntoView(scrollIntoViewOptions);
    });
    _this.state = {
      isCollapsed: false
    };
    _this.templateRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _createClass(Template, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        initialText = _this$props.initialText,
        text = _this$props.text,
        onChangeText = _this$props.onChange,
        onChangeBanner = _this$props.onChangeBanner,
        onChangeMedia = _this$props.onChangeMedia,
        maxTextLength = _this$props.maxTextLength,
        recommendedMediaSizes = _this$props.recommendedMediaSizes,
        banner = _this$props.banner,
        bannerMediaTypes = _this$props.bannerMediaTypes,
        media = _this$props.media,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        labels = _this$props.labels,
        images = _this$props.images,
        className = _this$props.className,
        childContainer = _this$props.childContainer,
        videoPlatformAccepted = _this$props.videoPlatformAccepted,
        error = _this$props.error,
        bannerError = _this$props.bannerError;
      var isCollapsed = this.state.isCollapsed;
      var hasError = !(0, _utils.isBlank)(error) || !(0, _utils.isBlank)(bannerError);
      var collapsableText = disabled && _utils.isMobile && text.length > _helpers.MOBILE_TEXT_LENGTH;
      var textValue = collapsableText && !isCollapsed ? "".concat((0, _utils.shortenText)(text, _helpers.MOBILE_TEXT_LENGTH), "...") : text;
      return /*#__PURE__*/_react["default"].createElement(_StyledTemplate.StyledTemplate, {
        className: className,
        hasError: hasError,
        readOnly: readOnly
      }, title && /*#__PURE__*/_react["default"].createElement("div", {
        className: "title"
      }, /*#__PURE__*/_react["default"].createElement(_heading.H3, null, title)), /*#__PURE__*/_react["default"].createElement(_Banner["default"], _extends({}, banner, {
        readOnly: readOnly,
        onChange: onChangeBanner,
        supportedMediaTypes: bannerMediaTypes,
        disabled: disabled,
        labels: labels,
        recommendedMediaSizes: recommendedMediaSizes,
        images: images,
        videoPlatformAccepted: videoPlatformAccepted,
        error: bannerError
      })), /*#__PURE__*/_react["default"].createElement(_StyledTemplate.StyledContent, null, /*#__PURE__*/_react["default"].createElement(_StyledTemplate.StyledContentItem, {
        ref: this.templateRef
      }, /*#__PURE__*/_react["default"].createElement(_input.RichTextarea, {
        toolbarHidden: readOnly,
        initialValue: initialText,
        value: textValue,
        collapsableText: collapsableText,
        expanded: isCollapsed,
        onToggleText: this.onToggleText,
        toolbar: {
          options: ['fontSize', 'colorPicker'],
          fontSize: {
            options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48]
          },
          colorPicker: {
            component: _ColorPicker["default"]
          },
          image: {
            previewImage: false
          }
        },
        childContainer: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, childContainer, /*#__PURE__*/_react["default"].createElement(_Media["default"], {
          readOnly: readOnly,
          data: media,
          isDescriptionEmpty: R.isEmpty(text),
          onChange: onChangeMedia,
          disabled: disabled,
          labels: labels,
          recommendedMediaSizes: recommendedMediaSizes,
          images: images,
          videoPlatformAccepted: videoPlatformAccepted
        })),
        onChange: function onChange(markup, plainText) {
          onChangeText('description', markup);
          onChangeText('plainText', plainText);
        },
        placeholder: labels.TEXT_PLACEHOLDER,
        maxLength: maxTextLength,
        disabled: disabled,
        ariaDescribedBy: "rewardDescription",
        error: error
      }))));
    }
  }]);
  return Template;
}(_react["default"].PureComponent);
Template.defaultProps = {
  readOnly: false,
  disabled: false,
  title: '',
  initialText: null,
  text: '',
  banner: {},
  media: [],
  onChange: function onChange() {},
  onChangeBanner: function onChangeBanner() {},
  onChangeMedia: function onChangeMedia() {},
  labels: {},
  images: {},
  maxTextLength: 100,
  recommendedMediaSizes: {},
  childContainer: null,
  videoPlatformAccepted: [],
  bannerMediaTypes: _config.MEDIA_TYPE,
  className: null,
  error: null,
  bannerError: null
};
Template.propTypes = {
  readOnly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  initialText: _propTypes["default"].string,
  text: _propTypes["default"].string,
  banner: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string,
    order: _propTypes["default"].number
  }),
  bannerMediaTypes: _propTypes["default"].shape({}),
  media: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string
  })),
  onChange: _propTypes["default"].func,
  onChangeBanner: _propTypes["default"].func,
  onChangeMedia: _propTypes["default"].func,
  maxTextLength: _propTypes["default"].number,
  labels: _propTypes["default"].shape({
    TEXT_PLACEHOLDER: _propTypes["default"].string
  }),
  recommendedMediaSizes: _propTypes["default"].shape({}),
  images: _propTypes["default"].shape({}),
  className: _propTypes["default"].string,
  childContainer: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].node]),
  error: _propTypes["default"].string,
  bannerError: _propTypes["default"].string,
  videoPlatformAccepted: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
Template.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onToggleText",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Template",
  "props": {
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "title": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "initialText": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "text": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "banner": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "src": {
            "name": "string",
            "required": false
          },
          "alt": {
            "name": "string",
            "required": false
          },
          "order": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false
    },
    "media": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "src": {
              "name": "string",
              "required": false
            },
            "alt": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onChangeBanner": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onChangeMedia": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "labels": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "TEXT_PLACEHOLDER": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "images": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "maxTextLength": {
      "defaultValue": {
        "value": "100",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "recommendedMediaSizes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "childContainer": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "element"
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "videoPlatformAccepted": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "bannerMediaTypes": {
      "defaultValue": {
        "value": "MEDIA_TYPE",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "bannerError": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = Template;
exports["default"] = _default;